import { render, staticRenderFns } from "./AdditionalClaimantsInput.vue?vue&type=template&id=245146b6"
import script from "./AdditionalClaimantsInput.vue?vue&type=script&lang=js"
export * from "./AdditionalClaimantsInput.vue?vue&type=script&lang=js"
import style0 from "./AdditionalClaimantsInput.vue?vue&type=style&index=0&id=245146b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports